import { motion } from 'motion/react';
import { useContext } from 'react';

import { formatDate2 } from '@/Utils/formatDate';

import classes from './P2PAdminPanel.module.css';
import { P2PContext } from './P2PContext';
import { UserWhiteListType } from '@/types/key-exchange';

interface IProps {
    user: UserWhiteListType;
}
const P2PUsersListItem: React.FC<IProps> = props => {
    const { user } = props;
    const context = useContext(P2PContext);
    const { activeUserItem, setActiveUserItem } = context;

    const chooseUser = () => {
        setActiveUserItem(user);
    };

    return (
        <motion.li
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.01 }}
            onClick={chooseUser}
            className={`${
                activeUserItem && activeUserItem.id === user.id
                    ? classes['active-user']
                    : ''
            } ${classes['list-item']}`}>
            <div className={classes['item-title']}>
                <p>{user?.name}</p>
                <p className={classes['date']}>
                    {formatDate2({
                        date: new Date(user.created_at),
                        returnTime: true,
                    })}
                </p>
                <h5 className={classes['name']}>{user.user_id}</h5>
            </div>
        </motion.li>
    );
};
export default P2PUsersListItem;
